import React from 'react'

import classNames from 'classnames'

import styles from './SymbiosisButton.pcss'
import {
	AddComponentProps,
	PolymorphicReactComponentWithRef,
} from 'symbiosis-uikit/dist/utils'

export type SymbiosisButtonVariant = 'white' | 'black' | 'green'

interface Props {
	variant?: SymbiosisButtonVariant
}

export const SymbiosisButton = React.forwardRef<
	HTMLButtonElement,
	AddComponentProps<Props, 'button'>
>(function Button(
	{ as, className, variant = 'black', disabled, ...props },
	ref
): JSX.Element {
	const Component = as || 'button'

	const containerClassNames: (string | undefined)[] = []
	if (variant === 'black') {
		containerClassNames.push(styles.black)
	} else if (variant === 'white') {
		containerClassNames.push(styles.white)
	} else {
		containerClassNames.push(styles.green)
	}

	if (disabled) {
		containerClassNames.push(styles.disabled)
	}

	return (
		<Component
			className={classNames(
				styles.container,
				...containerClassNames,
				className
			)}
			ref={ref}
			disabled={disabled}
			{...props}
		/>
	)
}) as PolymorphicReactComponentWithRef<Props, 'button'>
